import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { MapWithMultipleLocations } from '../../../../../../services/Maps'
import { hideLoadingBox, showMessageBox } from '../../../../../../store/actions/system.actions'
import ModalAssocCarga from './ModalAssocCarga/ModalAssocCarga'
import useRoteirizacaoMapa, { LOAD_MESSAGE } from './RoteirizacaoMapaHook'

function RoteirizacaoMapa({
  dispatch,
  customers,
  addDeliveriesToVehicle,
  selectedVeiculo,
  loadCounter,
  updateLoadCounter,
}) {
  const { state, localDispatch } = useRoteirizacaoMapa()

  useEffect(() => {
    localDispatch.onInit(customers)
  }, [customers])

  useEffect(() => {
    localDispatch.canOpenMarker(selectedVeiculo)
  }, [selectedVeiculo])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.ASSOCIATE_DELIVERIES:
        addDeliveriesToVehicle(state.customers)
        localDispatch.resetState()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <div
        className="p-col-12"
        style={{
          height: 500,
          filter: state.isLoading ? 'blur(5px)' : 'none',
          pointerEvents: state.isLoading ? 'none' : 'all',
        }}
      >
        <MapWithMultipleLocations
          customers={state.customers}
          openModal={localDispatch.onMarkerClicked}
          changeLoadStatus={localDispatch.changeLoadStatus}
        />
      </div>
      <ModalAssocCarga
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        loadCounter={loadCounter}
        updateLoadCounter={updateLoadCounter}
        show={state.showModal}
        customer={state.selectedCustomer}
      />
    </>
  )
}

export default connect()(RoteirizacaoMapa)
